<script lang="ts">
  import {onMount} from 'svelte';

  export let color1="";
  export let color2="";

  onMount(() => {
    // 首次启动动画
    startAnimation();
  })

  // 定义一个函数来设置动画的开始时间
  function startAnimation() {
    // 获取动画元素
    const animate1 = document.getElementById('animate1');
    const animate2 = document.getElementById('animate2');
    if (animate1 && animate2) {
      // 设置动画的开始时间为当前时间 + 2秒
      animate1.beginElement()?.beginElementAt(2);
      animate2.beginElement()?.beginElementAt(2);
    }
    // 在动画结束后 2 秒再次调用该函数，实现循环播放
    let timer = setTimeout(() => {
      startAnimation()
      clearTimeout(timer)
      timer = null
    }, 2000);
  }
</script>

<svg t="1742552575648" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9258" width="32" height="32">
  <defs>
    <linearGradient id="banner-title-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stop-color={color2}>
        <animate id="animate1" begin="2.2s" attributeName="stop-color" values="{color2};{color1};{color2}" dur="1.2s" repeatCount="1" />
      </stop>
      <stop offset="100%" stop-color={color1}>
        <animate id="animate2" begin="2.2s" attributeName="stop-color" values="{color1};{color2};{color1}" dur="1.2s" repeatCount="1" />
      </stop>
    </linearGradient>
  </defs>
  <path
    d="M48.614141 512.514586C48.614141 256.995556 256.478384 49.131313 512.003879 49.131313c255.51903 0 463.38198 207.864242 463.38198 463.383273 0 255.525495-207.864242 463.388444-463.38198 463.388444C256.478384 975.904323 48.614141 768.040081 48.614141 512.514586L48.614141 512.514586zM909.191758 512.514586c0-219.015758-178.173414-397.186586-397.186586-397.186586-219.020929 0-397.193051 178.172121-397.193051 397.186586 0 219.019636 178.172121 397.191758 397.193051 397.191758C731.018343 909.707636 909.191758 731.535515 909.191758 512.514586L909.191758 512.514586zM567.474424 701.247354l165.761293-163.939556c9.797818-9.667232 12.249212-23.964444 7.378747-35.979636-0.297374-0.757657-1.025293-1.353697-1.387313-2.085495-1.521778-3.075879-3.176727-6.156929-5.72897-8.737616-0.028444-0.029737-0.065939-0.029737-0.094384-0.065939-0.036202-0.029737-0.036202-0.067232-0.067232-0.100848L568.962586 325.510465c-12.907313-12.944808-33.857939-12.974545-46.796283-0.071111-6.491798 6.454303-9.733172 14.964364-9.733172 23.434343 0 8.442828 3.206465 16.914101 9.662061 23.368404l106.843798 107.177374L313.407354 479.419475c-18.302707 0-33.101576 14.828606-33.101576 33.096404 0 18.27297 14.797576 33.101576 33.101576 33.101576l317.287434 0-109.756768 108.56598c-6.556444 6.454303-9.830141 14.995394-9.830141 23.53002 0 8.409212 3.176727 16.818424 9.566384 23.272727C533.513051 713.990465 554.467556 714.121051 567.474424 701.247354L567.474424 701.247354zM567.474424 701.247354"
    fill="url(#banner-title-gradient)"
    p-id="9259"
  />
</svg>
